import { apiClient } from "./client";
import type {
  AgenciesPaginated,
  AgencyCreate,
  AgencyUpdate,
  Agency,
  MessageResponse,
} from "@/types";

export async function listAgencies(
  groupId?: number,
  search?: string
): Promise<AgenciesPaginated> {
  const params: Record<string, unknown> = {};
  if (groupId !== undefined) params.group_id = groupId;
  if (search) params.search = search;
  const response = await apiClient.get<AgenciesPaginated>("/agencies", {
    params,
  });
  return response.data;
}

export async function getAgency(agencyId: number): Promise<Agency> {
  const response = await apiClient.get<Agency>(`/agencies/${agencyId}`);
  return response.data;
}

export async function createAgency(data: AgencyCreate): Promise<Agency> {
  const response = await apiClient.post<Agency>("/agencies", data);
  return response.data;
}

export async function updateAgency(
  agencyId: number,
  data: AgencyUpdate
): Promise<Agency> {
  const response = await apiClient.patch<Agency>(
    `/agencies/${agencyId}`,
    data
  );
  return response.data;
}

export async function deleteAgency(
  agencyId: number
): Promise<MessageResponse> {
  const response = await apiClient.delete<MessageResponse>(
    `/agencies/${agencyId}`
  );
  return response.data;
}
